import { authService } from 'auth/services';

import { HTTP_RESPONSE_STATUS_CODES } from '../utils/constants';

interface ApiResponse {
  ok: boolean;
  status: number;
  statusText: string;
  url: string;
  json: () => Promise<Record<string, unknown>>;
}

interface ApiJsonResponse {
  isSuccess?: boolean;
  errorMessage?: string;
  code?: string | number;
  message?: string;
  [key: string]: unknown;
}

export class ResponseValidator {
  static validateResponse = async (response: ApiResponse): Promise<ApiJsonResponse> => {
    const json = (await response.json()) as ApiJsonResponse;
    if (!response.ok) {
      if (ResponseValidator.isUserAuthenticationError(response.status, json)) {
        authService.handleLogout();
      }
      const message = await ResponseValidator.extractErrorMessage(response, json);
      throw new Error(message);
    }

    const { isSuccess, errorMessage, code } = json;

    if (isSuccess === false) {
      throw new Error(`${code} (${errorMessage})`);
    }

    return json;
  };

  static extractErrorMessage = async (response: ApiResponse, json: ApiJsonResponse): Promise<string> => {
    const REACT_APP_APIGEE_HOST = import.meta.env.VITE_APIGEE_HOST;
    let errorMessage = `${response.status} (${response.statusText})`;
    if (response.url.includes(REACT_APP_APIGEE_HOST)) {
      const { message = '' } = json;
      errorMessage = message.includes('Recaptcha-Response-Token') ? `${response.status} (${message})` : errorMessage;
    }
    return errorMessage;
  };

  static isUserAuthenticationError = (status: number, json: ApiJsonResponse): boolean => {
    if (status !== HTTP_RESPONSE_STATUS_CODES.UNAUTHORIZED) {
      return false;
    }
    return json.code === '41' && json.message === 'Invalid or Expired credentials';
  };
}
